import React from 'react'

import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import { Spacings, subheading } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartNodeHeader } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeHeader'

import { IconStyle, WrapperStyle, TitleStyle } from './NodeHeader.style'
interface NodeHeaderProps {
  header: FlowChartNodeHeader
}

export const NodeHeader = ({ header }: NodeHeaderProps) => {
  const { title, icon: headerIcon } = header

  const iconString = headerIcon
    ? convertToIconString(headerIcon.icon, { size: headerIcon.size, color: headerIcon.color })
    : null

  return (
    <view
      style={{
        ...WrapperStyle,
        background: header.color,
      }}
    >
      {iconString && <sprite image={iconString} style={IconStyle} />}
      <view
        style={{
          ...TitleStyle,
          marginLeft: iconString ? Spacings.SMALL_HORIZONTAL : Spacings.MEDIUM_HORIZONTAL,
        }}
      >
        <richtext text={title} style={subheading} />
      </view>
    </view>
  )
}
